const PropTypes = require('prop-types');
const React = require('react');
const { CURRENCY_SYMBOLS } = require('components/shared/constants.js');

const currencySymbol = (currencyCode) => CURRENCY_SYMBOLS[currencyCode.toLowerCase()];

const LayawayWarning = function (props) {
  if (!props.hasLayawayEnabled) {
    return false;
  }

  if (!props.directCheckoutSelected) {
    return false;
  }

  if (props.shopCurrency === props.payoutCurrency) {
    return false;
  }

  const warningText = I18n.t(
    'js.dashboard.selling.shopPolicies.directCheckoutProfile.bankAccountFields.layawayWarning',
    {
      shopCurrencySymbol: currencySymbol(props.shopCurrency),
      shopCurrencyCode: props.shopCurrency,
    }
  );

  return (
    <p
      className={props.className}
      data-layaway-warning
      dangerouslySetInnerHTML={{ __html: warningText }}
    />
  );
};

LayawayWarning.propTypes = {
  shopCurrency: PropTypes.string.isRequired,
  payoutCurrency: PropTypes.string.isRequired,
  directCheckoutSelected: PropTypes.bool.isRequired,
  hasLayawayEnabled: PropTypes.bool.isRequired,
  className: PropTypes.string,
};

module.exports = LayawayWarning;




// WEBPACK FOOTER //
// ./javascripts/components/shop/layaway_warning.jsx